module.exports = __webpack_public_path__ + "img/logo-ft.3d63282b.png";